import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import resourcebadge from "../../../../assets/images/docs/resources/badges.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  resourcebadge,
  React
};